import { of } from 'rxjs';
import { concatMap, delay } from 'rxjs/operators';
import { randomNumberGenerator } from '../utils/numberGenerator';
export var randomDelay = function (min, max, generator, scheduler) {
    if (generator === void 0) { generator = randomNumberGenerator; }
    return concatMap(function (value) { return of(value).pipe(delay(generator(min, max), scheduler)); });
};
//# sourceMappingURL=randomDelay.js.map